import { ReservationDetail } from './reservation-detail';
import { ReservationCity } from './reservation-city';
import { Customer } from './customer';
import { Agency } from './agency';

export class Reservation {
    id: string;
    name: string;
    customerId: string;
    customer: Customer;
    agency: Agency;
    agencyId: string;
    portalId: string;
    publisherId: string;
    locationId: string;
    reservationDetails: ReservationDetail[] = [];
    reservationCities: ReservationCity[] = [];
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/reservation.ts